import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=c4d48bd4&scoped=true&"
import script from "./changePassword.vue?vue&type=script&lang=ts&"
export * from "./changePassword.vue?vue&type=script&lang=ts&"
import style0 from "./changePassword.vue?vue&type=style&index=0&id=c4d48bd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d48bd4",
  null
  
)

export default component.exports